import { Suspense, lazy } from "react";
// react-router-dom
import { Navigate, useRoutes } from "react-router-dom";
// paths
import { PATH_DASHBOARD, PATH_AUTH, ROOTS_NOT_FOUND } from "./paths";
// layouts
import LayoutGenerator from "../layouts";
import AuthLayout from "src/layouts/AuthLayout";
import ProgramAvailablity from "src/components/ProgramAvailablity";

// --------------------------------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  return (
    <Suspense fallback={<>Loading</>}>
      <Component {...props} />
    </Suspense>
  );
};

// --------------------------------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    { path: "/", element: <Navigate to={PATH_DASHBOARD.home} replace /> },
    {
      path: PATH_DASHBOARD.home,
      element: (
        <LayoutGenerator>
          <HomePage />
        </LayoutGenerator>
      ),
    },
    {
      path: PATH_AUTH.root,
      element: <LayoutGenerator />,
      children: [
        { path: PATH_AUTH.signIn, element: <SignIn /> },
        { path: PATH_AUTH.signUp, element: <SignUp /> },
        { path: PATH_AUTH.transit, element: <TransitPage /> },
      ],
    },
    {
      path: PATH_DASHBOARD.algorithmForm,
      element: (
        <LayoutGenerator>
          <AlgorithmForm />
        </LayoutGenerator>
      ),
    },
    {
      path: PATH_DASHBOARD.nutrition,
      element: (
        <LayoutGenerator>
          <ProgramAvailablity>
            <NutritionPage />
          </ProgramAvailablity>
        </LayoutGenerator>
      ),
    },
    {
      path: PATH_DASHBOARD.workout,
      element: (
        <LayoutGenerator>
          <ProgramAvailablity>
            <WorkoutPage />
          </ProgramAvailablity>
        </LayoutGenerator>
      ),
    },
    {
      path: PATH_DASHBOARD.chats,
      element: (
        <LayoutGenerator>
          <ChatsPage />
        </LayoutGenerator>
      ),
    },
    {
      path: "*",
      children: [
        { path: "404", element: <NotFoundPage /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
    {
      path: "*", // Catch-all route for 404
      element: <Navigate to={ROOTS_NOT_FOUND} replace />,
    },
  ]);
}

// Auth
// -- Sign In
const SignIn = Loadable(lazy(() => import("../pages/auth/SignIn")));
// -- Sign Up
const SignUp = Loadable(lazy(() => import("../pages/auth/SignUp")));
// -- Transit
const TransitPage = Loadable(lazy(() => import("../pages/auth/TransitPage")));

// Home
const HomePage = Loadable(lazy(() => import("../pages/HomePage")));

// Nutrition
const NutritionPage = Loadable(lazy(() => import("../pages/NutritionPage")));

// Workout
const WorkoutPage = Loadable(lazy(() => import("../pages/WorkoutPage")));

// -- Algorithm Form
const AlgorithmForm = Loadable(lazy(() => import("../pages/AlgorithmForm")));

// Chats
const ChatsPage = Loadable(lazy(() => import("../pages/ChatsPage")));

const NotFoundPage = Loadable(lazy(() => import("../pages/NotFoundPage")));
